var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","fill":"currentColor","transform":"rotate(-180 5 3)"},[React.createElement("rect",{"width":"2","height":"7","x":"2.182","y":"-.318","rx":"1","transform":"rotate(135 3.182 3.182)","key":0}),React.createElement("rect",{"width":"2","height":"7","x":"6.182","y":"-.318","rx":"1","transform":"rotate(-135 7.182 3.182)","key":1})]));
}

ChevronUp.defaultProps = {"width":"10","height":"6","viewBox":"0 0 10 6"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
